import { fabric } from "fabric";
import { canvasRegistry } from "util/canvas/GlobalFabricCanvasRegistry";

const OriginalCanvas = fabric.Canvas;

const CanvasProxy = new Proxy(OriginalCanvas, {
  construct(target, args: ConstructorParameters<typeof fabric.Canvas>, newTarget) {
    const instance: fabric.Canvas = Reflect.construct(target, args, newTarget);
    instance.fabricCanvasRegistryId = canvasRegistry.register(instance);
    return instance;
  },
});

fabric.Canvas = CanvasProxy;
